"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scroll_to_1 = require("./dom-helpers/util/scroll-to");
/**
 * Helps scroll into view a selected item from a list.
 * For example the TimePicker will automatically show selected value when the popup is opened.
 */
var PopupScrollManager = /** @class */ (function () {
    function PopupScrollManager() {
    }
    PopupScrollManager.prototype.scrollTo = function (selected, list, focused, onMove) {
        var lastVisible = this._visible;
        var lastItem = this._focused;
        this._visible = !(!list.offsetWidth || !list.offsetHeight);
        this._focused = focused;
        var changed = lastItem !== focused;
        var shown = this._visible && !lastVisible;
        if (shown || (this._visible && changed)) {
            if (onMove) {
                onMove(selected, list, focused);
            }
            else {
                if (this._scrollCancel) {
                    this._scrollCancel();
                }
                this._scrollCancel = scroll_to_1.scrollTo(selected, list);
            }
        }
    };
    return PopupScrollManager;
}());
exports.PopupScrollManager = PopupScrollManager;
